export default __webpack_public_path__ + "static/kayiArcher2-9d3df93dcc3645d6db47a717ac533b8a.png";